import React from 'react'
import './issueLoader.css'

export const IssueLoader = () => {
	return (
		<div className="loaderWrapper">
			<div className="circ z">
				<div className="head">
					<div className="eye"></div>
				</div>
				<div className="body"></div>
				<div className="hands"></div>
				<div className="load">Терпим . . .</div>
			</div>

			<div className="subText">
				Ожидание не должно превышать 10 секунд.
				Если заказ не отображается — обновите страницу. 
				При отсутствии результата напишите в чат по заказу.
			</div>
		</div>
	)
}
